import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { DropdownButton } from '../Buttons';
import { Menu, DropdownMenu, MenuLink } from '../Menus';

/**
 *
 * @typedef {{
 *  0: import('./Breadcrumbs').Crumb,
 *  1: import('./Breadcrumbs').Crumb,
 * } & Array<import('./Breadcrumbs').Crumb>} AtLeastFiveCrumbs
 *
 * @typedef {{
 *  crumbs: AtLeastFiveCrumbs,
 *  ariaLabel: string,
 * }} Props
 * @type {React.FC<Props>} BreadcrumbsDropdown
 */
const BreadcrumbsDropdown = ({ ariaLabel, crumbs }) => {
  return (
    <li className="breadcrumb-item inline-block after:mx-2 after:my-0">
      <Menu>
        <DropdownButton
          aria-label={ariaLabel}
          className="breadcrumb-dropdown"
          data-testid="breadcrumb-dropdown-button"
          type="subtle"
        >
          ...
        </DropdownButton>
        <DropdownMenu>
          {crumbs.map((crumb) => (
            <MenuLink
              as={Link}
              key={`breadcrumb-dropdown-${crumb.label}`}
              to={crumb.uri}
            >
              {crumb.label}
            </MenuLink>
          ))}
        </DropdownMenu>
      </Menu>
    </li>
  );
};

BreadcrumbsDropdown.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  crumbs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      uri: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default BreadcrumbsDropdown;
